import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.GeographicFocusEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    geographicFocusEnumList: { items: data, total },
  } = await sdk.getListGeographicFocusEnum(
    filterSortPage({
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { geographicFocusEnum: data } = await sdk.getOneGeographicFocusEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { geographicFocusEnumMany: data } =
    await sdk.getManyGeographicFocusEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const geographicFocusEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
